"use client";

import { getLink } from "@utils/linkUtils";
import { useLocale } from "next-intl";
import Script from "next/script";
import React, { FC, useEffect, useState } from "react";

import { CustomLink } from "@/types";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "../ui/Button/Button";
import Icon from "../ui/Icon/Icon";

interface Props {
  cta: CustomLink;
}
const StickyCta: FC<Props> = ({ cta }) => {
  const locale = useLocale();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const viewportHeight = window.innerHeight;

      if (scrollPosition > viewportHeight / 4.5) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`fixed z-50 right-m top-auto flex items-center mx-auto rounded-full btn-primary-gold backdrop-blur-md !border-0 shadow-strong bottom-m overflow-hidden mt-0 mb-0 transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      <Button
        className={`btn p-[10px] !border-0 flex justify-between items-center font-medium group transition-all duration-300 ease-in-out`}
        variant={ButtonVariant.PRIMARY}
        size={ButtonSize.SMALL}
        theme={ButtonTheme.GOLD}
        href={getLink(cta, locale)}
      >
        <>
          {cta.link?.icon && (
            <Icon name={cta.link?.icon || ""} size="24" className="stroke-black transition-transform duration-300 ease-in-out group-hover:ml-xs" />
          )}
          <span className="mx-xs hidden group-hover:block whitespace-nowrap group-hover:ml-3 transition-all duration-300 ease-in-out">
            {cta.label}
          </span>
        </>
      </Button>
    </div>
  );
};
export default StickyCta;
